
import { Component, Vue } from "vue-property-decorator";
import * as QRCode from "@/utils/qrcode.js";

@Component
export default class Qrcode extends Vue {
  render() {
    return (
      <div class="qrcode-wrap">
        <div ref="android">
          <div class="download">android下载</div>
        </div>
        <div ref="ios">
          <div class="download">ios下载</div>
        </div>
      </div>
    );
  }
  mounted() {
    new (QRCode.default as any)(this.$refs.android, {
      width: 100,
      height: 100,
      colorDark: "#48d3b9",
      text: "http://app.mi.com/details?id=com.ty.tyclient&ref=search",
      logo: require("@/assets/logo-qrcode.jpg")
    });
    new (QRCode.default as any)(this.$refs.ios, {
      width: 100,
      height: 100,
      colorDark: "#48d3b9",
      text:
        "https://apps.apple.com/cn/app/%E5%A4%A9%E5%AE%87%E5%85%AC%E5%AF%93/id1516970990",
      logo: require("@/assets/logo-qrcode.jpg")
    });
  }
}
